module.exports = __webpack_public_path__ + "static/media/c1.57eaa523.jpg";